<sq-metadata-item *ngFor="let item of items"
    [record]="record"
    [item]="item"
    (select)="select($event.item, $event.valueItem)"
    [showTitle]="showTitles"
    [showIcon]="showIcons"
    [showCounts]="showCounts"
    [showEntityTooltip]="showEntityTooltip"
    [clickable]="clickable"
    [tabular]="tabular"
    [collapseRows]="collapseRows"
    [query]="query || searchService.query">
</sq-metadata-item>
